module.exports = __webpack_public_path__ + "img/grip-vertical.09a5c5b2.svg";